<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 24/9/2020
  -->

<template>
	<div class="base-notification-root">
		<transition :name="animationName">
			<div v-show="isShowing">
				<slot/>
			</div>
		</transition>
	</div>
</template>

<script>
export default {
	name: "BaseNotification",

	data(){
		return {
			animationName:"slide",
			content:"",
			isShowing: false
		}
	},

	methods:{
		show(){
			this.animationName = "slide"
			this.isShowing = true
		},

		hide(){
			this.animationName = "slideLeave"
			this.isShowing = false
		}
	}
}
</script>

<style lang="scss">

.base-notification-root{
	z-index: 10000000000;
	position: fixed;
	right: 0;
	bottom: 0;
}

</style>
